import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction } from "react";
import * as S from "./styles";
import { IOnboardingChoices } from "~/types/account";
import { regions } from "~/constants/regions";
import RadioButton from "../ui/Radio";

type Props = {
  onboardingChoices: IOnboardingChoices;
  setOnboardingChoices: Dispatch<SetStateAction<IOnboardingChoices>>;
};

export const PreferredRegion = ({
  onboardingChoices,
  setOnboardingChoices,
}: Props) => {
  const { t } = useTranslation();

  return (
    <S.CardContainer>
      {regions?.map((region) => (
        <S.CardCategory
          key={region.value}
          className={
            onboardingChoices?.preferredRegion == region.value ? "active" : ""
          }
          onClick={() =>
            setOnboardingChoices((prev) => ({
              ...prev,
              preferredRegion: region.value,
            }))
          }>
          <RadioButton
            checked={onboardingChoices?.preferredRegion == region.value}
            onChange={() =>
              setOnboardingChoices((prev) => ({
                ...prev,
                preferredRegion: region.value,
              }))
            }
          />
          {t(region.labelKey)}
        </S.CardCategory>
      ))}
    </S.CardContainer>
  );
};
